import { Layout } from "@/components/Layout";
import { Link } from "react-router-dom";
import { ROUTE_PATHS } from "@/lib/index";

export default function MentionsLegales() {
  return (
    <Layout>
      <div className="min-h-screen bg-white py-20">
        <div className="max-w-4xl mx-auto px-6 md:px-8">
          <div className="mb-12">
            <Link 
              to={ROUTE_PATHS.HOME}
              className="text-sm text-[#6e6e73] hover:text-[#1d1d1f] transition-colors mb-4 inline-block"
            >
              ← Retour à l'accueil
            </Link>
            <h1 className="text-4xl md:text-5xl font-bold mb-4" style={{ color: '#1d1d1f' }}>
              Mentions Légales
            </h1>
            <p className="text-sm text-[#6e6e73] mt-2">
              Mise à jour : 31 mars 2026
            </p>
          </div>

          <div className="prose prose-lg max-w-none">
            <div className="mb-8 p-6 bg-[#f5f5f7] rounded-lg">
              <p className="text-[#1d1d1f] leading-relaxed">
                Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la confiance en l'économie numérique, il est précisé aux utilisateurs du site <strong>camillevega.fr</strong> l'identité des différents intervenants dans le cadre de sa réalisation et de son suivi.
              </p>
            </div>

            <section className="mb-12">
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#1d1d1f' }}>
                1. Éditeur du site
              </h2>
              <div className="p-6 bg-[#f5f5f7] rounded-lg">
                <p className="text-[#1d1d1f] mb-2"><strong>Raison sociale :</strong> Camille Vega — SARL</p>
                <p className="text-[#1d1d1f] mb-2"><strong>Forme juridique :</strong> Société à Responsabilité Limitée (SARL)</p>
                <p className="text-[#1d1d1f] mb-2"><strong>Capital social :</strong> [À compléter] €</p>
                <p className="text-[#1d1d1f] mb-2"><strong>SIRET :</strong> 988 977 260 00013</p>
                <p className="text-[#1d1d1f] mb-2"><strong>Siège social :</strong> 60 rue François Premier, 75008 Paris, France</p>
                <p className="text-[#1d1d1f] mb-2"><strong>Directeur de la publication :</strong> Camille Vega de Hoyos</p>
                <p className="text-[#1d1d1f] mb-2"><strong>Email :</strong> <a href="mailto:camille@camillevega.com" className="text-[#C9793A] hover:underline">camille@camillevega.com</a></p>
                <p className="text-[#1d1d1f]"><strong>Téléphone :</strong> 06 95 77 11 67</p>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#1d1d1f' }}>
                2. Hébergement du site
              </h2>
              <div className="p-6 bg-[#f5f5f7] rounded-lg">
                <p className="text-[#1d1d1f] mb-2"><strong>Hébergeur :</strong> Vercel Inc.</p>
                <p className="text-[#1d1d1f] mb-2"><strong>Adresse :</strong> 440 N Barranca Ave #4133, Covina, CA 91723, États-Unis</p>
                <p className="text-[#1d1d1f]"><strong>Site web :</strong> <a href="https://vercel.com" target="_blank" rel="noopener noreferrer" className="text-[#C9793A] hover:underline">vercel.com</a></p>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#1d1d1f' }}>
                3. Propriété intellectuelle
              </h2>
              <p className="text-[#1d1d1f] leading-relaxed mb-4">
                L'ensemble du contenu du site <strong>camillevega.fr</strong> (textes, images, vidéos, graphismes, logos, icônes, sons, logiciels, bases de données, etc.) est la propriété exclusive de <strong>Camille Vega — SARL</strong>, sauf mention contraire explicite.
              </p>
              <p className="text-[#1d1d1f] leading-relaxed mb-4">
                Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de Camille Vega.
              </p>
              <p className="text-[#1d1d1f] leading-relaxed">
                Toute exploitation non autorisée du site ou de l'un quelconque des éléments qu'il contient sera considérée comme constitutive d'une contrefaçon et poursuivie conformément aux dispositions des articles L.335-2 et suivants du Code de Propriété Intellectuelle.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#1d1d1f' }}>
                4. Responsabilité
              </h2>
              <p className="text-[#1d1d1f] leading-relaxed mb-4">
                Les informations contenues sur ce site sont aussi précises que possible et le site est périodiquement remis à jour, mais peut toutefois contenir des inexactitudes, des omissions ou des lacunes.
              </p>
              <p className="text-[#1d1d1f] leading-relaxed mb-4">
                Si vous constatez une lacune, erreur ou ce qui paraît être un dysfonctionnement, merci de bien vouloir le signaler par email à <a href="mailto:camille@camillevega.com" className="text-[#C9793A] hover:underline">camille@camillevega.com</a>, en décrivant le problème de la manière la plus précise possible.
              </p>
              <p className="text-[#1d1d1f] leading-relaxed mb-4">
                <strong>Camille Vega — SARL</strong> décline toute responsabilité :
              </p>
              <ul className="list-disc ml-6 space-y-2 text-[#1d1d1f] mb-4">
                <li>Pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur le site</li>
                <li>Pour tous dommages résultant d'une intrusion frauduleuse d'un tiers ayant entraîné une modification des informations mises à disposition sur le site</li>
                <li>Pour tous dommages directs ou indirects résultant de l'utilisation du site</li>
                <li>Pour les contenus des sites vers lesquels des liens hypertextes peuvent renvoyer</li>
              </ul>
              <p className="text-[#1d1d1f] leading-relaxed">
                L'utilisateur du site s'engage à accéder au site en utilisant un matériel récent, ne contenant pas de virus et avec un navigateur de dernière génération mis à jour.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#1d1d1f' }}>
                5. Liens hypertextes
              </h2>
              <p className="text-[#1d1d1f] leading-relaxed mb-4">
                Le site <strong>camillevega.fr</strong> peut contenir des liens hypertextes vers d'autres sites présents sur le réseau Internet. Les liens vers ces autres ressources vous font quitter le site camillevega.fr.
              </p>
              <p className="text-[#1d1d1f] leading-relaxed mb-4">
                Il est possible de créer un lien vers la page de présentation de ce site sans autorisation expresse de l'éditeur. Aucune autorisation ou demande d'information préalable ne peut être exigée par l'éditeur à l'égard d'un site qui souhaite établir un lien vers le site de l'éditeur.
              </p>
              <p className="text-[#1d1d1f] leading-relaxed">
                Il convient toutefois d'afficher ce site dans une nouvelle fenêtre du navigateur. Cependant, l'éditeur se réserve le droit de demander la suppression d'un lien qu'il estime non conforme à l'objet du site camillevega.fr.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#1d1d1f' }}>
                6. Protection des données personnelles
              </h2>
              <p className="text-[#1d1d1f] leading-relaxed mb-4">
                Le site <strong>camillevega.fr</strong> est conforme au Règlement Général sur la Protection des Données (RGPD — UE 2016/679).
              </p>
              <p className="text-[#1d1d1f] leading-relaxed mb-4">
                Pour plus d'informations sur la collecte, l'utilisation et la protection de vos données personnelles, veuillez consulter notre <Link to={ROUTE_PATHS.CONFIDENTIALITE} className="text-[#C9793A] hover:underline font-semibold">Politique de Confidentialité</Link>.
              </p>
              <div className="p-6 bg-[#C9793A] bg-opacity-10 border-l-4 border-[#C9793A] rounded">
                <p className="text-[#1d1d1f] mb-2">
                  <strong>Responsable du traitement des données :</strong> Camille Vega de Hoyos
                </p>
                <p className="text-[#1d1d1f] mb-2">
                  <strong>Email :</strong> <a href="mailto:camille@camillevega.com" className="text-[#C9793A] hover:underline">camille@camillevega.com</a>
                </p>
                <p className="text-[#1d1d1f]">
                  <strong>Délégué à la Protection des Données (DPO) :</strong> [À compléter si applicable]
                </p>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#1d1d1f' }}>
                7. Cookies
              </h2>
              <p className="text-[#1d1d1f] leading-relaxed mb-4">
                Le site <strong>camillevega.fr</strong> utilise des cookies strictement nécessaires à son fonctionnement.
              </p>
              <p className="text-[#1d1d1f] leading-relaxed">
                Pour plus d'informations sur l'utilisation des cookies, veuillez consulter notre <Link to={ROUTE_PATHS.COOKIES} className="text-[#C9793A] hover:underline font-semibold">Politique de Cookies</Link>.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#1d1d1f' }}>
                8. Droit applicable et juridiction compétente
              </h2>
              <p className="text-[#1d1d1f] leading-relaxed mb-4">
                Les présentes mentions légales sont régies par le droit français.
              </p>
              <p className="text-[#1d1d1f] leading-relaxed">
                En cas de litige et à défaut d'accord amiable, le litige sera porté devant les tribunaux français conformément aux règles de compétence en vigueur.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#1d1d1f' }}>
                9. Contact
              </h2>
              <p className="text-[#1d1d1f] leading-relaxed mb-4">
                Pour toute question ou demande d'information concernant le site, vous pouvez nous contacter :
              </p>
              <div className="p-6 bg-[#f5f5f7] rounded-lg">
                <p className="text-[#1d1d1f] mb-2"><strong>Par email :</strong> <a href="mailto:camille@camillevega.com" className="text-[#C9793A] hover:underline">camille@camillevega.com</a></p>
                <p className="text-[#1d1d1f] mb-2"><strong>Par téléphone :</strong> 06 95 77 11 67</p>
                <p className="text-[#1d1d1f]"><strong>Par courrier :</strong> Camille Vega — SARL, 60 rue François Premier, 75008 Paris, France</p>
              </div>
            </section>

            <div className="mt-12 p-6 bg-[#f5f5f7] border-l-4 border-[#C9793A] rounded">
              <p className="text-[#1d1d1f] text-center font-semibold">
                Camille Vega — SARL — Shut Up & Close
              </p>
              <p className="text-[#1d1d1f] text-center text-sm mt-2">
                60 rue François Premier, 75008 Paris · SIRET 988 977 260 00013
              </p>
              <p className="text-[#1d1d1f] text-center text-sm">
                <a href="mailto:camille@camillevega.com" className="text-[#C9793A] hover:underline">camille@camillevega.com</a> · <a href="https://camillevega.fr" target="_blank" rel="noopener noreferrer" className="text-[#C9793A] hover:underline">camillevega.fr</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
